module.exports = __webpack_public_path__ + "static/media/500L.7cb2d7b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/pure_tone/500L.mp3
// module id = A7hb
// module chunks = 1